import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';

import { trans, getResourcePath, useSoyuzData } from '@spotahome/soyuz/client';
import {
  Section,
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  FooterSimplified,
  SpottyCat,
  UserInfoProvider,
  GoogleOneTap,
  AppBanner,
  CitiesProvider
} from '@spotahome/ui-library';

import LazyLoginSignUpModal from '@spotahome/landings-common/src/components/LoginSignupModal';
import Hero from '@spotahome/landings-common/src/components/Hero';
import HeaderContainer from '@spotahome/landings-common/src/components/HeaderContainer';

import {
  MQ_TABLET_MIN_WIDTH,
  MQ_MOBILE_MAX_WIDTH
} from '@spotahome/ui-library/src/tenant/components/utils/seoConstants';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import ZohoChatbot from '@spotahome/ui-library/src/tenant/components/ZohoChatbot/ZohoChatbot';

import AboutDifferent from './components/AboutDifferent';
import AboutStart from './components/AboutStart';
import AboutMission from './components/AboutMission';
import AboutBuild from './components/AboutBuild';

import AboutPress from './components/AboutPress';

const AboutUsContainer = () => {
  const { [AboutUsContainer.NAME]: requestedData } = useSoyuzData();
  const { deviceType, deviceViewType, initialCookie, userId } = requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <CitiesProvider skipAllCities>
            <ToastContainer />
            {!userId && <GoogleOneTap />}
            <AppBanner source="home" deviceType={deviceType} />
            <SpottyCat />
            <ZohoChatbot />
            <NoSSR>
              <MediaQuery minWidth={MQ_TABLET_MIN_WIDTH}>
                <Hero
                  menu={<HeaderContainer tracking="ga-about-us" color="dark" />}
                  title={trans('about-us.hero.title')}
                  backgroundImage={`url(${getResourcePath(
                    '/images/about-us/background-header.jpg'
                  )})`}
                />
              </MediaQuery>
            </NoSSR>

            <NoSSR>
              <MediaQuery maxWidth={MQ_MOBILE_MAX_WIDTH}>
                <Hero
                  menu={<HeaderContainer tracking="ga-about-us" color="dark" />}
                  title={trans('about-us.hero.title')}
                  backgroundImage={`url(${getResourcePath(
                    '/images/about-us/mobile-header.jpg'
                  )})`}
                />
              </MediaQuery>
            </NoSSR>

            <Section background="light">
              <AboutDifferent />
            </Section>

            <Section background="light">
              <AboutStart />
            </Section>

            <Section background="skin">
              <AboutMission />
            </Section>

            <AboutBuild />

            <Section background="light">
              <AboutPress />
            </Section>
            <LazyLoginSignUpModal deviceViewType={deviceViewType} />
            <FooterSimplified />
          </CitiesProvider>
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

AboutUsContainer.NAME = 'AboutUsContainer';

AboutUsContainer.requestData = async req => {
  return {
    data: {
      deviceType: req.device.type,
      deviceViewType: req.device.viewType,
      initialCookie: req.headers.cookie,
      userId: req.userId
    }
  };
};

export default AboutUsContainer;
